/** Design of record §6: verify's severities in the student's words, grouped for the deck screen. */
import type { FindingWire, Severity } from "../api/api";

export function label(severity: Severity): string {
  switch (severity) {
    case "OK":
      return "Complete";
    case "WARN":
      return "Worth a look";
    case "GAP":
      return "Not covered by this book";
    case "NEEDS-REVIEW":
      return "Could not be read";
  }
}

export type Group = { chapter: number | null; items: FindingWire[] };

export function groupFindings(findings: FindingWire[]): Group[] {
  const by = new Map<number | null, FindingWire[]>();
  for (const f of findings) {
    if (f.severity === "OK") continue;
    const list = by.get(f.chapter_number) ?? [];
    list.push(f);
    by.set(f.chapter_number, list);
  }
  return [...by.entries()]
    .sort(([a], [b]) => (a === null ? -1 : b === null ? 1 : a - b))
    .map(([chapter, items]) => ({ chapter, items }));
}
